export const getStatsTime = (obj) => {
  for (const [key] of Object.entries(obj)) {
    if (obj[key]) return key
  }
  return "All match"
}
